import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { ExternalMapLayerState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: ExternalMapLayerState = getDefaultState();

const namespaced: boolean = true;

export const externalMapLayers: Module<ExternalMapLayerState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
